import React, { Fragment, useEffect } from 'react'
import BuildingLayer from './BuildingLayer'
import ObstacleLayer from './ObstacleLayer'
import AttackLayer from './AttackLayer'
import ReCalculate from './ReCalculate'
import { useSelector } from 'react-redux'

function ClearDraw(props) {
  const { selectedScenarioId } = useSelector(state => state)

  useEffect(() => {
    props.draw.deleteAll()
  }, [selectedScenarioId])

  return null
}

export default function Layers(props) {
  const { selectedScenarioId, remoteStorage } = useSelector(state => state)
  return (
    <Fragment>
      {remoteStorage.obstacles ? <ClearDraw draw={props.draw} /> : null}
      {selectedScenarioId ? (
        <>
          <AttackLayer draw={props.draw} />
          <ObstacleLayer draw={props.draw} />
        </>
      ) : null}
      <BuildingLayer geojson={props.geojson} />
      <ReCalculate draw={props.draw} />
    </Fragment>
  )
}
